module.exports = __webpack_public_path__ + "static/media/honey.edb008d3.webp";